import { render, staticRenderFns } from "./rili.vue?vue&type=template&id=44004272&scoped=true&"
import script from "./rili.vue?vue&type=script&lang=js&"
export * from "./rili.vue?vue&type=script&lang=js&"
import style0 from "./rili.vue?vue&type=style&index=0&id=44004272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44004272",
  null
  
)

export default component.exports